var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSparkle = function SvgIconSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5.5a1 1 0 0 1 1 1v1.25h1.25a1 1 0 1 1 0 2H17.5V6a1 1 0 1 1-2 0V4.75h-1.25a1 1 0 0 1 0-2h1.25V1.5a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.501 4.487a1.75 1.75 0 0 1 2.64.828v.002l1.762 4.78 4.783 1.762a1.75 1.75 0 0 1 0 3.282h-.002l-4.78 1.762-1.762 4.78-.001.003a1.75 1.75 0 0 1-3.281 0l-.001-.003-1.762-4.78-4.78-1.762h-.002a1.75 1.75 0 0 1 0-3.282h.002l4.78-1.762 1.762-4.78v-.002a1.75 1.75 0 0 1 .642-.828m1 2.16-1.565 4.246a1.76 1.76 0 0 1-1.043 1.042L3.647 13.5l4.246 1.565a1.76 1.76 0 0 1 1.043 1.042l1.564 4.247 1.565-4.247a1.76 1.76 0 0 1 1.043-1.042l4.246-1.565-4.246-1.565a1.76 1.76 0 0 1-1.043-1.042zm3.298 3.412",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.75a1 1 0 0 1 1 1v.5h.5a1 1 0 1 1 0 2H22v.5a1 1 0 1 1-2 0v-.5h-.5a1 1 0 0 1 0-2h.5v-.5a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconSparkle;